import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { withLDConsumer } from 'launchdarkly-react-client-sdk'

import { openModal } from '@/reducers/ui/ui.redux'
import { editAlertConfiguration } from '@/reducers/realtime/realtime.actions'
import { Button } from '@/components/buttons/Button'
import { PageHeader } from '@/components/headers/PageHeader'

import { AlertWizard } from './AlertWizard/AlertWizard'

const AlertHeaderComponent = ({ readOnly = false, loading = false }) => {
  const { currentlyOpenModalId: modal } = useSelector((state) => state.ui)
  const state = useSelector((state) => state)
  const dispatch = useDispatch()
  const {
    data: { agents: organizationUsers, tags: organizationTags },
  } = useSelector((state) => state.realtimeCoaching)
  const { realtimeNewAlertConfiguration } = state
  const { user_id: currentUserId } = useSelector((state) => state.currentUser)
  const updateAlertConfiguration = (values) => {
    const body = {
      ...values,
    }

    const trigger_on = []

    for (const item of body.triggerItems) {
      trigger_on.push({
        cid: item.playbook.value,
        path:
          values.triggerType === 'absence'
            ? `requirement_missed - ${item.path.value}`
            : item.path.value,
      })
    }

    const managers = (body?.managers || []).map((manager) => manager.value)
    const onlyYourselfSelected = managers.length === 1 && managers[0] === currentUserId

    const newAlert = {
      data: {
        name: body.name,
        message: body.message || '',
        type: body.alertType,
        all_users: body.alertsFor === 'all',
        users:
          body.alertsFor === 'agents' && body.selectedUsers && body.selectedUsers.length > 0
            ? body.selectedUsers.map((item) => item.value)
            : [],
        tags:
          body.alertsFor === 'tags' && body.selectedTags && body.selectedTags.length > 0
            ? body.selectedTags.map((item) => item.value)
            : [],
        trigger_on,
        audible: body.audible,
        active: body.active,
      },
    }

    if (!onlyYourselfSelected) {
      newAlert.data.managers = managers
    }

    dispatch(editAlertConfiguration(newAlert, `${body.name} has been created`))
  }

  const createNewAlertConfiguration = (values) => {
    updateAlertConfiguration(values)
  }

  const openAlertModal = () => {
    dispatch(openModal('newAlert'))
  }

  return (
    <PageHeader
      title={`My Alerts ${readOnly ? '(Read Only)' : ''}`}
      actions={
        <div className="flex-align-center small-gap">
          <Button
            brand
            data-testid="add-alert-button"
            onClick={openAlertModal}
            disabled={readOnly || loading}
            loading={loading}
          >
            Create Alert
          </Button>
          {modal === 'newAlert' && (
            <AlertWizard
              tags={organizationTags}
              handleSubmit={createNewAlertConfiguration}
              configPaths={realtimeNewAlertConfiguration.configPaths}
              organizationUsers={organizationUsers}
            />
          )}
        </div>
      }
    />
  )
}

export const AlertHeader = withLDConsumer()(AlertHeaderComponent)
